$(document).ready(function () {
  function updateProductTitleWithSwatch(swatchElement) {
    if (!swatchElement || !swatchElement.length) return;

    const title = swatchElement.attr('data-original-title') || swatchElement.text().trim();
    if (!title) return;

    const lang = $('html').attr('lang');
    const isEnglish = lang === 'en';

    let $mainTitle = $('.t4s-product__title');
    let titleproduct = $mainTitle.text();

    if (isEnglish) {
      if (titleproduct.toLowerCase().includes('ceramic') && !titleproduct.includes(title)) {
        const updatedTitle = titleproduct.replace(/(ceramic)(.*)/i, '$1 ' + title);
        $mainTitle.text(updatedTitle.trim());
      }
    } else {
      if (titleproduct.toLowerCase().includes('ceramique') && !titleproduct.includes(title)) {
        const updatedTitle = titleproduct.replace(/(ceramique)(.*)/i, '$1 ' + title);
        $mainTitle.text(updatedTitle.trim());
      }
    }

    $('#relatedProductsList .related-product .color__or_info a').each(function () {
      let $link = $(this);
      let linkText = $link.text();

      if (isEnglish) {
        if (linkText.toLowerCase().includes('ceramic') && !linkText.includes(title)) {
          const updatedLinkText = linkText.replace(/(ceramic)(.*)/i, '$1 ' + title);
          $link.text(updatedLinkText.trim());
        }
      } else {
        if (linkText.toLowerCase().includes('ceramique') && !linkText.includes(title)) {
          const updatedLinkText = linkText.replace(/(ceramique)(.*)/i, '$1 ' + title);
          $link.text(updatedLinkText.trim());
        }
      }
    });
  }

  const waitForSwatch = setInterval(function () {
    const selectedSwatch = $('.swatch-color-custom.is--selected');
    if (selectedSwatch.length > 0) {
      updateProductTitleWithSwatch(selectedSwatch);
      clearInterval(waitForSwatch);
    }
  }, 100);

  $(document).on('click', '.swatch-color-custom', function () {
    updateProductTitleWithSwatch($(this));
  });

  $('.taille-cubiste li').on('click', function() {
      $('.taille-cubiste li').removeClass('active'); 
      $(this).addClass('active');                   
      $(this).find('input[type="radio"]').prop('checked', true);
  });

  // CUSTOM FILTER
  // const addClassfilter = setInterval(function () {
  //     const $block = $('.is--blockidcouleur-dautre-matiere');
  //     if ($block.length > 0) {
  //         $block.find('ul li').each(function () {
  //             const $li = $(this);
  //             $li.addClass('color-filter');
  //             const color = $li.find('a').clone().children().remove().end().text().trim();
  //             const bgcolor = '';
  
  //             if ($li.find('.t4s-value-count + .custom-span').length === 0) {
  //                 $('<span class="custom-span">'+bgcolor+'</span>').insertAfter($li.find('.t4s-value-count'));
  //             }
  //         });
  
  //         clearInterval(addClassfilter);
  //     }
  // }, 200);
  
  // const intervalId = setInterval(function() {
  //     let replaced = false;
  //     $('.t4s-col-item .t4s-filter__values a').each(function() {
  //       let textNode = $(this).contents().filter(function() {
  //         return this.nodeType === 3 && this.nodeValue.trim() === 'men';
  //       });
  //       if (textNode.length) {
  //         textNode[0].nodeValue = 'homme';
  //         replaced = true;
  //       }
  //     });

  //     $('.t4s-active-filters__remove-filter').each(function() {
  //       if ($(this).text().trim() === 'men') {
  //         $(this).text('homme');
  //         replaced = true;
  //       }
  //     });
    
  //     if (replaced) {
  //         clearInterval(intervalId);
  //     }
  // }, 500);

  // const observer = new MutationObserver(function () {
  //     $('.t4s-col-item .t4s-filter__values a').each(function() {
  //         let textNode = $(this).contents().filter(function() {
  //           return this.nodeType === 3 && this.nodeValue.trim() === 'men';
  //         });
  //         if (textNode.length) {
  //           textNode[0].nodeValue = 'homme';
  //           replaced = true;
  //         }
  //     });

  //     $('.t4s-active-filters__remove-filter').each(function() {
  //         if ($(this).text().trim() === 'men') {
  //           $(this).text('homme');
  //           replaced = true;
  //         }
  //     });
  // });
  
  // observer.observe(document.querySelector('.t4s-filter-area'), {
  //     childList: true,
  //     subtree: true
  // });

  const intervalId = setInterval(function() {
    let replaced = false;

    $('.t4s-col-item .t4s-filter__values a').each(function() {
      let textNode = $(this).contents().filter(function() {
        return this.nodeType === 3 && this.nodeValue.trim() === 'men';
      });
      if (textNode.length) {
        textNode[0].nodeValue = 'homme';
        replaced = true;
      }
    });

    $('.t4s-active-filters__remove-filter').each(function() {
      if ($(this).text().trim() === 'men') {
        $(this).text('homme');
        replaced = true;
      }
    });

    $('.t4s-facet').each(function() {
      var $facet = $(this);
      var $items = $facet.find('.t4s-filter__values li');
      if ($items.length <= 1) {
        $facet.remove(); 
        replaced = true;
      }
    });

    if (replaced) {
      clearInterval(intervalId);
    }
  }, 500);

  const observer = new MutationObserver(function() {
    $('.t4s-col-item .t4s-filter__values a').each(function() {
      let textNode = $(this).contents().filter(function() {
        return this.nodeType === 3 && this.nodeValue.trim() === 'men';
      });
      if (textNode.length) {
        textNode[0].nodeValue = 'homme';
      }
    });

    $('.t4s-active-filters__remove-filter').each(function() {
      if ($(this).text().trim() === 'men') {
        $(this).text('homme');
      }
    });

    $('.t4s-facet').each(function() {
      var $facet = $(this);
      var $items = $facet.find('.t4s-filter__values li');
      if ($items.length <= 1) {
        $facet.remove();
      }
    });
  });

  observer.observe(document.querySelector('.t4s-filter-area'), {
    childList: true,
    subtree: true
  });

  if (document.documentElement.lang === "en") {

    const translations = {
      "Argent": "Silver",
      "Blanc": "White",
      "Jaune": "Yellow",
      "Noir": "Black",
      "Rose": "Pink",
      "bébé": "baby",
      "enfant": "child",
      "femme": "woman",
      "homme": "man"
    };

    $('.t4s-active-filters').css('visibility', 'hidden');

    function replaceTexts() {
      let replaced = false;

      $('.t4s-col-item .t4s-filter__values a').each(function() {
        let textNode = $(this).contents().filter(function() {
          return this.nodeType === 3 && translations.hasOwnProperty(this.nodeValue.trim());
        });
        if (textNode.length) {
          let original = textNode[0].nodeValue.trim();
          textNode[0].nodeValue = translations[original];
          replaced = true;
        }
      });

      $('.t4s-active-filters__remove-filter').each(function() {
        let original = $(this).text().trim();
        if (translations.hasOwnProperty(original)) {
          $(this).text(translations[original]);
          replaced = true;
        }
      });

      $('.t4s-active-filters').css('visibility', 'visible');

      return replaced;
    }

    const intervalId = setInterval(function() {
      if (replaceTexts()) {
        clearInterval(intervalId);
      }
    }, 500);

    const observer = new MutationObserver(function () {
      replaceTexts();
    });

    observer.observe(document.querySelector('.t4s-filter-area'), {
      childList: true,
      subtree: true
    });
  }

});
